import React, { useEffect, useRef } from "react";

interface Props {
  members: any[];
  onClose: () => void;
}

const getInitials = (firstName: string, lastName: string) =>
  `${firstName[0] ?? ""}`.toUpperCase();

const getColor = (leader: boolean) =>
  leader ? "bg-green-500" : "bg-orange-500";

const PeopleWithAccessPopup: React.FC<Props> = ({ members, onClose }) => {
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      ref={popupRef}
      className="rounded-[0.2rem] shadow-lg p-4 pb-6 bg-white w-[25rem] z-50 absolute top-12 right-0 border"
    >
      <h3 className="text-gray-800 mb-5 text-sm 2xl:text-base font-semibold">
        People with access
      </h3>
      <ul className="space-y-5">
        {members.map((member) => {
          const { first_name, last_name } = member.user;
          const initials = getInitials(first_name, last_name);
          const bgColor = getColor(member.leader);

          return (
            <li key={member.user.id} className="flex items-center gap-3">
              <div
                className={`w-8 h-8 rounded-full text-white font-bold flex items-center justify-center ${bgColor}`}
              >
                {initials}
              </div>
              <div className="flex justify-between items-center flex-1">
                <p className="text-sm font-medium text-gray-900 leading-[1.1]">
                  {first_name} {last_name} <br />
                  <span className="text-[0.65rem] text-gray-400">
                    {member.user.email}
                  </span>
                </p>
                <span className="text-blue-600 font-semibold text-xs 2xl:text-sm">
                  {member.leader ? "Leader" : "Member"}
                </span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PeopleWithAccessPopup;
